import { createContext, useContext } from 'react'

export function createAppLayout<T>() {
  const AppLayoutContext = createContext<T | null>(null)

  function AppLayoutProvider({ children, value }: { children: React.ReactNode; value: T }) {
    return <AppLayoutContext.Provider value={value}>{children}</AppLayoutContext.Provider>
  }

  function useAppLayout(): T {
    const ctx = useContext(AppLayoutContext)
    if (ctx === null) throw new Error('useAppLayout must be used within AppLayoutProvider')
    return ctx
  }

  return { AppLayoutContext, AppLayoutProvider, useAppLayout }
}
